import { render } from "./SubmittedComponent.vue?vue&type=template&id=15ec5ffe&scoped=true"
import script from "./SubmittedComponent.vue?vue&type=script&lang=js"
export * from "./SubmittedComponent.vue?vue&type=script&lang=js"

import "./SubmittedComponent.vue?vue&type=style&index=0&id=15ec5ffe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\rh\\Documents\\GitHub\\handover-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ec5ffe"]])

export default __exports__